'use strict';

const formats = {
  TD1: 'TD1',
  TD2: 'TD2',
  TD3: 'TD3',
  SWISS_DRIVING_LICENSE: 'SWISS_DRIVING_LICENSE'
};
Object.freeze(formats);

module.exports = formats;



// WEBPACK FOOTER //
// ./src/formats.js